import { useTransferStyles } from '../forms/Transfer.styles';

const SolidDivider = () => {
  const { styles } = useTransferStyles();
  return <div className={styles.solidDivider} />;
};

export default SolidDivider;
